import { makeStyles } from "@material-ui/styles"
import { CELL_PADDING, CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  root: {
    fontSize: 20,
    color: "inherit",
    width: CELL_WIDTHS.EXPAND.DEPTH_1 - CELL_PADDING*2,
    minWidth: CELL_WIDTHS.EXPAND.DEPTH_1 - CELL_PADDING*2,
    "&.d2": {
      width: CELL_WIDTHS.EXPAND.DEPTH_2 - CELL_PADDING*2,
      minWidth: CELL_WIDTHS.EXPAND.DEPTH_2 - CELL_PADDING*2,
    },
    "&.d3": {
      width: CELL_WIDTHS.EXPAND.DEPTH_3 - CELL_PADDING*2,
      minWidth: CELL_WIDTHS.EXPAND.DEPTH_3 - CELL_PADDING*2,
    },
    "&.d4": {
      width: CELL_WIDTHS.EXPAND.DEPTH_4 - CELL_PADDING*2,
      minWidth: CELL_WIDTHS.EXPAND.DEPTH_4 - CELL_PADDING*2,
    },
  },
  header: {
    color: theme.palette.text.primary + "bf",
  },
  arrow: {
    padding: 5,
    boxSizing: "content-box",
    width: 24,
    height: 24,
  },
  badge: {
    backgroundColor: "transparent",
    color: theme.props.text.lighter,
    fontWeight: 600,
    top: "22%",
    right: "22%",
  }
}));

export default useStyle;
